var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: "".concat(_vm.currentPackage),
    staticClass: "page__package-form"
  }, [_c('div', {
    staticClass: "back-to-home rounded d-none d-sm-block"
  }, [_c('a', {
    staticClass: "btn btn-icon btn-soft-primary",
    attrs: {
      "href": "https://brevisvelox.com"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "home"
    }
  })], 1)]), _c('section', {
    staticClass: "d-flex flex-column h-100 align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col col-md-6 px-0 px-md-2"
  }, [_vm.currentPackage.form_img ? _c('div', {
    staticClass: "page__package-form__image-wrapper"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.helperImgPath(_vm.currentPackage.form_img),
      "alt": _vm.currentPackage.title
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "row justify-content-center my-4"
  }, [_c('div', {
    staticClass: "col col-md-10 col-lg-8 col-xl-7 d-flex flex-column"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentPackage.form_text)
    }
  }), _c('FormulateForm', {
    attrs: {
      "schema": _vm.currentPackage.form
    },
    on: {
      "submit": _vm.onSubmit
    },
    model: {
      value: _vm.formFields,
      callback: function callback($$v) {
        _vm.formFields = $$v;
      },
      expression: "formFields"
    }
  }, [_c('FormulateInput', {
    staticClass: "mt-3",
    attrs: {
      "type": "submit",
      "name": "Na raziskavo"
    }
  })], 1)], 1)]), _c('ProgressBarContainer', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('p', [_vm._v(" Sklop "), _c('span', [_vm._v("1")]), _vm._v(" od " + _vm._s(_vm.packageLength) + " ")])];
      },
      proxy: true
    }, {
      key: "bar",
      fn: function fn() {
        return [_c('b-progress', {
          staticClass: "rounded w-100",
          attrs: {
            "value": 1,
            "max": _vm.packageLength,
            "height": "0.5rem",
            "variant": "primary"
          }
        })];
      },
      proxy: true
    }])
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }